import styled from 'styled-components'

import Button from '../button/button-base'
import { GridContainerWithBackground } from '../grid-container'

const Wrapper = styled(GridContainerWithBackground)`
  color: ${props => props.theme.colors.white};
  height: calc(100vw * 1.57); // Responsively preserve banner aspect ratio (up to 1200px height).
  max-height: 1200px;

  @media ${props => props.theme.queries.desktopAndUp} {
    height: calc(100vw * 0.425); // Responsively preserve banner aspect ratio.
  }
`
const ContentWrapper = styled('div')`
  grid-column: col-start 1 / col-end 4;
  z-index: 1; // put above Overlay if it is present.
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  
  @media ${props => props.theme.queries.desktopAndUp} {
    grid-column: col-start 1 / col-end 10;
    justify-content: center;
  }

  ${Button} {
    align-self: stretch;
    @media ${props => props.theme.queries.desktopAndUp} {
      align-self: flex-start;
    }
  }
`

const TextStyles = styled('div')`
  padding-bottom: 24px;
  padding-top: 69px;

  @media ${props => props.theme.queries.desktopAndUp} {
    padding-top: 0;
  }

  * {
    color: ${props => props.theme.colors.white};
  }

  .hero__subtitle p {
    ${props => props.theme.typography.heading};
  }

  sup {
    top: -1em;
    font-size: 0.4em;
    font-weight: 300;
  }
`

export { 
  Wrapper,
  ContentWrapper,
  TextStyles,
}